// extracted by mini-css-extract-plugin
export var active = "_cl-2";
export var recordingDot = "_cl-1";
export var recordingIndicator = "_cl-0";